/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { professionIdGet } from '../fn/profession/profession-id-get';
import { ProfessionIdGet$Params } from '../fn/profession/profession-id-get';
import { ProfessionModel } from '../models/profession-model';
import { ProfessionModelSearchResultModel } from '../models/profession-model-search-result-model';
import { professionPost } from '../fn/profession/profession-post';
import { ProfessionPost$Params } from '../fn/profession/profession-post';
import { professionSearchProfessionPost } from '../fn/profession/profession-search-profession-post';
import { ProfessionSearchProfessionPost$Params } from '../fn/profession/profession-search-profession-post';

@Injectable({ providedIn: 'root' })
export class MDIProfessionService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `professionSearchProfessionPost()` */
  static readonly ProfessionSearchProfessionPostPath = '/Profession/SearchProfession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `professionSearchProfessionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  professionSearchProfessionPost$Response(params?: ProfessionSearchProfessionPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ProfessionModelSearchResultModel>> {
    return professionSearchProfessionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `professionSearchProfessionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  professionSearchProfessionPost(params?: ProfessionSearchProfessionPost$Params, context?: HttpContext): Observable<ProfessionModelSearchResultModel> {
    return this.professionSearchProfessionPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ProfessionModelSearchResultModel>): ProfessionModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `professionIdGet()` */
  static readonly ProfessionIdGetPath = '/Profession/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `professionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  professionIdGet$Response(params: ProfessionIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ProfessionModel>> {
    return professionIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `professionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  professionIdGet(params: ProfessionIdGet$Params, context?: HttpContext): Observable<ProfessionModel> {
    return this.professionIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ProfessionModel>): ProfessionModel => r.body)
    );
  }

  /** Path part for operation `professionPost()` */
  static readonly ProfessionPostPath = '/Profession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `professionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  professionPost$Response(params?: ProfessionPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return professionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `professionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  professionPost(params?: ProfessionPost$Params, context?: HttpContext): Observable<string> {
    return this.professionPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
